import { type ReactElement } from 'react'
import { useQueryState, parseAsStringLiteral } from 'nuqs'
import { PAGE_HEIGHT } from '@util'
import { createFileRoute } from '@tanstack/react-router'
import { Page, TButton } from '@components'
import { SAMPLE_PANELS, type SamplePanelId } from './types'
import { SampleTTable } from './table'
import { SampleTextEditor } from './SampleTextEditor'
import SampleTDrawer from './SampleTDrawer'
import { SampleTButtons } from './SampleTButtons'
import { SampleTAlert } from './SampleTAlert'
import { SampleNav } from './SampleNav'
import { SampleMarkdownDisplay } from './SampleMarkdownDisplay'
import { SampleListItems } from './SampleListItems'
import { SampleEntitlements } from './SampleEntitlements'
import { SampleCharts } from './SampleCharts'
import { SampleFormFields } from './form'

function SampleComponents(): ReactElement {
  const [activePanel, setActivePanel] = useQueryState<SamplePanelId>(
    'panel',
    parseAsStringLiteral(SAMPLE_PANELS).withDefault('TButton')
  )

  return (
    <Page>
      <Page.Heading title='Sample Components' />
      <div className={`${PAGE_HEIGHT} flex overflow-hidden`}>
        <SampleNav activeId={activePanel} onChange={(id) => setActivePanel(id as SamplePanelId)} />
        <div className='flex-1 overflow-auto'>
          <ActivePanel activeId={activePanel} />
        </div>
      </div>
    </Page>
  )
}

const ActivePanel = ({ activeId }: { activeId: SamplePanelId }): ReactElement => {
  switch (activeId) {
    case 'TButton':
      return <SampleTButtons />
    case 'TAlert':
      return <SampleTAlert />
    case 'FormFields':
      return <SampleFormFields />
    case 'ListItem':
      return <SampleListItems />
    case 'Drawer':
      return <SampleTDrawer />
    case 'Table':
      return <SampleTTable />
    case 'TextEditor':
      return <SampleTextEditor />
    case 'Entitlements':
      return <SampleEntitlements />
    case 'Charts':
      return <SampleCharts />
    case 'MarkdownDisplay':
      return <SampleMarkdownDisplay />
  }
}

export const Route = createFileRoute('/sampleComponents/')({
  component: SampleComponents,
})
